import { render, staticRenderFns } from "./Barn.vue?vue&type=template&id=67696bc2&"
import script from "./Barn.vue?vue&type=script&lang=ts&"
export * from "./Barn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports